module.exports = __webpack_public_path__ + "static/img/audio.fc4c47fa.svg";